import React from 'react';
import { Search, Disc, Droplet, Wrench, Gauge, Car } from 'lucide-react';

const services = [
  {
    icon: Search,
    title: 'Check Engine Diagnostics',
    description: 'Advanced computer diagnostics to quickly identify and resolve check engine light issues and performance problems.',
    image: 'https://images.unsplash.com/photo-1615906655593-ad0386982a0f?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1ODB8MHwxfHNlYXJjaHwxfHxtZWNoYW5pY3xlbnwwfHx8fDE3NjUyNDM4Nzh8MA&ixlib=rb-4.1.0&q=85'
  },
  {
    icon: Disc,
    title: 'Brakes & Suspension',
    description: 'Complete brake system repairs, pad and rotor replacement, and suspension work to keep your vehicle safe and smooth.',
    image: 'https://images.unsplash.com/photo-1599256872237-5dcc0fbe9668?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1ODB8MHwxfHNlYXJjaHw0fHxtZWNoYW5pY3xlbnwwfHx8fDE3NjUyNDM4Nzh8MA&ixlib=rb-4.1.0&q=85'
  },
  {
    icon: Droplet,
    title: 'Oil Change & Fluids',
    description: 'Regular maintenance services including oil changes, fluid checks, and filter replacements to extend your engine life.',
    image: 'https://images.unsplash.com/photo-1487754180451-c456f719a1fc?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1ODB8MHwxfHNlYXJjaHwzfHxtZWNoYW5pY3xlbnwwfHx8fDE3NjUyNDM4Nzh8MA&ixlib=rb-4.1.0&q=85'
  },
  {
    icon: Wrench,
    title: 'Engine & Transmission Repair',
    description: 'Expert engine and transmission diagnostics and repair services for all makes and models.',
    image: 'https://images.unsplash.com/photo-1615906655593-ad0386982a0f?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1ODB8MHwxfHNlYXJjaHwxfHxtZWNoYW5pY3xlbnwwfHx8fDE3NjUyNDM4Nzh8MA&ixlib=rb-4.1.0&q=85'
  },
  {
    icon: Gauge,
    title: 'Preventive Maintenance',
    description: 'Scheduled maintenance services to prevent breakdowns and keep your vehicle running at peak performance.',
    image: 'https://images.unsplash.com/photo-1487754180451-c456f719a1fc?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1ODB8MHwxfHNlYXJjaHwzfHxtZWNoYW5pY3xlbnwwfHx8fDE3NjUyNDM4Nzh8MA&ixlib=rb-4.1.0&q=85'
  },
  {
    icon: Car,
    title: 'Foreign & Domestic',
    description: 'Complete service for all vehicle makes and models, both foreign and domestic brands.',
    image: 'https://images.unsplash.com/photo-1599256872237-5dcc0fbe9668?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1ODB8MHwxfHNlYXJjaHw0fHxtZWNoYW5pY3xlbnwwfHx8fDE3NjUyNDM4Nzh8MA&ixlib=rb-4.1.0&q=85'
  }
];

const ServicesSection = () => {
  return (
    <section id="services" className="relative py-24 bg-neutral-950">
      {/* Carbon Fiber Background Pattern */}
      <div className="absolute inset-0 carbon-fiber opacity-10"></div>
      
      <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Header */}
        <div className="text-center mb-16">
          <div className="inline-block mb-4">
            <span className="text-red-600 text-sm font-bold tracking-widest uppercase">Our Services</span>
            <div className="h-0.5 bg-red-600 mt-2 mx-auto"></div>
          </div>
          <h2 className="text-4xl sm:text-5xl font-bold text-white mb-6">
            Complete Auto Repair Services
          </h2>
          <p className="text-xl text-white/70 max-w-3xl mx-auto">
            From routine maintenance to complex repairs, we've got you covered
          </p>
        </div>

        {/* Services Grid */}
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
          {services.map((service, index) => (
            <div
              key={index}
              className="group bg-neutral-900 border border-white/10 hover:border-red-600/50 transition-all duration-300 overflow-hidden"
              style={{ borderRadius: '0px' }}
            >
              {/* Service Image */}
              <div className="relative h-48 overflow-hidden">
                <img
                  src={service.image}
                  alt={service.title}
                  className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-110"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-neutral-900 via-neutral-900/50 to-transparent"></div>
                
                {/* Icon */}
                <div className="absolute bottom-4 left-4">
                  <div className="w-12 h-12 bg-red-600 flex items-center justify-center" style={{ borderRadius: '0px' }}>
                    <service.icon className="w-6 h-6 text-white" />
                  </div>
                </div>
              </div>

              {/* Content */}
              <div className="p-6">
                <h3 className="text-xl font-bold text-white mb-3 group-hover:text-red-600 transition-colors">
                  {service.title}
                </h3>
                <p className="text-white/70 text-base leading-relaxed mb-4">
                  {service.description}
                </p>
                <button className="text-red-600 font-medium flex items-center gap-2 hover:gap-3 transition-all duration-300">
                  Learn More
                  <span>→</span>
                </button>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default ServicesSection;